angular.module('lf.common')

.controller('AuthenticationCtrl', function ($scope, $rootScope, authenticationService, checkoutService, gtmService) {
  
	/*
	 * Dummy Login Form
	 */
	var loginForm = { 
			login: "sdabade01@leapfrog.test",
			password: "password"
	};
	
	/* 
	 * Login User - 
	 * This function is used to log a user in with credentials provided
	 */
	$scope.loginUser = function($event) {
		var paramsObj = {};
		paramsObj["login"] = loginForm.login;
    	paramsObj["password"] = loginForm.password;
    	
		authenticationService.loginUser(paramsObj)
		.success(function(loginUserResponse) {
			if(loginUserResponse.success) {
				console.log("User logged in successfully.");
				lf.data.xhr.user = loginUserResponse.user;
				/* Output Structure 
  			   		{
  			 			success: true
  			 		}
				*/
				
				// Now that the user has logged in, get all the checkout data (shipping and payment) for this user.
				checkoutService.getCheckoutData({})
				.success(function(getCheckoutDataResponse) {
					console.log("Successfully received checkout data.");
					lf.data["checkoutData"] = getCheckoutDataResponse;
				});
			} else {
				console.log("Authentication failed.");
				/* Output Structure 
     			   {
     			 		success: false, 
     			    	error : {
     			    		code: "", 
     			    		message: "",
     			    		details: ["", ""]
     			    	}
   					}
				*/
			}
		});
	}
	
	/*
	 * Dummy Guest Login Form
	 */
	var guestLoginForm = { 
			emailAddress: "sdabade121814@leapfrog.test"
	};
	
	/* 
	 * Login Guest - 
	 * This function is used to log a guest user in by verifying that the email address
	 * provided by the guest does not exist in the system and initializing the web session
	 * (and also creating a Guest Vindicia account) 
	 * 
	 */
	$scope.loginGuest = function($event) {
		var paramsObj = {};
		paramsObj["emailAddress"] = guestLoginForm.emailAddress;
    	
		authenticationService.loginGuest(paramsObj)
		.success(function(loginGuestResponse) {
			if(loginGuestResponse.data.success) {
				console.log("Email Address provided by guest does not exist in our system.");
				lf.data.xhr.user = loginGuestResponse.data.user;
				/* Output Structure 
  			   		{
  			 			success: true,
  			 			emailAddress: "",
  			 			webSessionId: ""
  			 		}
				*/
			} else {
				console.log("Email Address provided by guest already exists in our system.");
				/* Output Structure 
     			   {
     			 		success: false, 
     			    	error : {
     			    		code: "", 
     			    		message: "",
     			    		details: ["", ""]
     			    	}
   					}
				*/
			}
		});
	}
});